const state = () => ({
  mentForUser: [], //存储当前面包屑数据
  menuList: [], //菜单list
});
const getters = {
  getMentForUser(state) {
    return state.mentForUser;
  },
  getMenuOutStudent() {
    return state.menuList;
  },
};
const mutations = {
  setMentForUser(state, list) {
    state.mentForUser = list;
  },
  setMenuList(state, list){
    state.menuList = list;
  }
};

const action={
  setMenu(context){
    context.commit('setMenuList')
  }
}

export default {
  state,
  getters,
  mutations,
  action,
};
